import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';
import '@backstage/ui/css/styles.css';
import '@xlrt/components/src/css/styles.css';
import './components/theme/fonts.css';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
